const ClockIcon = ({ color = '#475569' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="6.5" stroke={color} strokeWidth="1.3" />
    <path d="M8 4.5V8l2.2 2.2" stroke={color} strokeWidth="1.3" strokeLinecap="round" />
  </svg>
)

export default ClockIcon
